import { Route } from '@angular/router';

import { JhiHealthCheckComponent } from './health.component';

export const healthRoute: Route = {
    path: 'jhi-health',
    component: JhiHealthCheckComponent,
    data: {
        pageTitle: 'health.title'
    }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/health/health.route.ts